<template>
  <div
    v-if="!isTablet"
    class="programmirovanie__filters"
  >
    <v-select
      :value="direction"
      :items="directionsList"
      input-value="id"
      label="Все предметы"
      drop-down-image="/v2/catalog/repetitor/catalog/dropdown.svg"
      class="programmirovanie__filters_select"
      @change="$emit('update:direction', $event)"
    >
      <template #inner-dropdown>
        <img
          src="/v2/catalog/repetitor/close.svg"
          alt="x"
          class="programmirovanie__filters_select_close"
        >
      </template>
    </v-select>
    <v-select
      :value="format"
      :items="formatsList"
      input-value="id"
      label="Все цели"
      drop-down-image="/v2/catalog/repetitor/catalog/dropdown.svg"
      class="programmirovanie__filters_select"
      @change="$emit('update:format', $event)"
    >
      <template #inner-dropdown>
        <img
          src="/v2/catalog/repetitor/close.svg"
          alt="x"
          class="programmirovanie__filters_select_close"
        >
      </template>
    </v-select>
  </div>
  <div
    v-else
    class="programmirovanie__filters-mob"
  >
    <div class="programmirovanie__filters-mob_header">
      <p>Выбери категории</p>
    </div>

    <div class="programmirovanie__filters-mob_items">
      <button
        :class="['m-btn', { 'active': direction !== 'all' }]"
        @click="clickMobileCheap('direction')"
      >
        {{ directionName }}
        <img
          v-if="direction !== 'all'"
          src="/v2/catalog/repetitor/catalog/close-white.svg"
          alt="x"
        >
      </button>
      <button
        :class="['m-btn', { 'active': format !== 'all' }]"
        @click="clickMobileCheap('format')"
      >
        {{ formatName }}
        <img
          v-if="format !== 'all'"
          src="/v2/catalog/repetitor/catalog/close-white.svg"
          alt="x"
        >
      </button>
    </div>

    <div
      v-if="mobileFilter"
      class="programmirovanie__filters-shutter"
      @click="mobileFilter = false"
    >
      <div
        class="programmirovanie__filters-shutter_body"
        @click.stop
      >
        <button
          class="m-btn programmirovanie__filters-shutter_close"
          @click="mobileFilter = false"
        >
          <img
            src="/v2/catalog/repetitor/close.svg"
            alt="x"
          >
        </button>

        <div class="programmirovanie__filters-shutter_block">
          <p>Направления программирования</p>

          <div class="programmirovanie__filters-shutter_block_items">
            <template v-for="item in directionsList">
              <button
                v-if="item.id !== 'all'"
                :key="item.id"
                :class="['m-btn', { 'active': item.id === mobileDirection }]"
                @click="mobileDirection = item.id === mobileDirection ? 'all' : item.id"
              >
                {{ item.title }}
                <img
                  v-if="item.id === mobileDirection"
                  src="/v2/catalog/repetitor/catalog/close-white.svg"
                  alt="x"
                >
              </button>
            </template>
          </div>
        </div>

        <div class="programmirovanie__filters-shutter_block">
          <p>Все форматы</p>

          <div class="programmirovanie__filters-shutter_block_items">
            <template v-for="item in formatsList">
              <button
                v-if="item.id !== 'all'"
                :key="item.id"
                :class="['m-btn', { 'active': item.id === mobileFormat }]"
                @click="mobileFormat = item.id === mobileFormat ? 'all' : item.id"
              >
                {{ item.title.replace('Подготовка к ', '') }}
                <img
                  v-if="item.id === mobileFormat"
                  src="/v2/catalog/repetitor/catalog/close-white.svg"
                  alt="x"
                >
              </button>
            </template>
          </div>
        </div>

        <div class="programmirovanie__filters-shutter_bottom">
          <p class="programmirovanie__filters-shutter_found">
            {{ haveFilter ? `найдено ${mobFilteredCards.length}` : 'ㅤ' }}
          </p>
          <button
            class="programmirovanie__filters-shutter_apply m-btn"
            @click="applyMobileFilter"
          >
            Применить
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import VSelect from '~/components/common/vSelect.vue';
import catalogCards, { directionsList, formatsList } from './programmirovanieCards';

export default {
  name: 'ProgrammirovanieCatalogFilters',
  components: { VSelect },
  props: {
    direction: {
      type: String,
      default: 'all',
    },
    format: {
      type: String,
      default: 'all',
    },
  },
  data: () => ({
    mobileFilter: false,

    mobileDirection: 'all',
    mobileFormat: 'all',

    directionsList,
    formatsList,
  }),
  computed: {
    ...mapGetters({
      isTablet: 'isTablet',
    }),

    directionName() {
      return this.directionsList.find(({ id }) => id === this.direction).title;
    },
    formatName() {
      return this.formatsList.find(({ id }) => id === this.format).title;
    },
    haveFilter() {
      return this.mobileDirection !== 'all' || this.mobileFormat !== 'all';
    },

    mobFilteredCards() {
      return this.filteredCards(this.mobileDirection, this.mobileFormat);
    },
  },
  watch: {
    isTablet(val) {
      if (!val) {
        this.mobileFilter = false;
      }
    },
    mobileFilter(val) {
      if (val) {
        this.mobileDirection = this.direction;
        this.mobileFormat = this.format;
      }

      document.body.style.overflow = val ? 'hidden' : 'auto';
    },
  },
  methods: {
    applyMobileFilter() {
      this.mobileFilter = false;

      this.$emit('update:direction', this.mobileDirection);
      this.$emit('update:format', this.mobileFormat);
    },

    filteredCards(direction, format) {
      let filteredCards = [...catalogCards];

      if (direction !== 'all') {
        filteredCards = filteredCards.filter((card) => card.direction === direction || card.direction === 'all');
      }

      if (format !== 'all') {
        filteredCards = filteredCards.filter((card) => card.format === format);
      }

      return filteredCards;
    },

    clickMobileCheap(field) {
      if (field === 'direction') {
        if (this.direction === 'all') {
          this.mobileFilter = true;
        } else {
          this.$emit('update:direction', 'all');
        }
      }
      if (field === 'format') {
        if (this.format === 'all') {
          this.mobileFilter = true;
        } else {
          this.$emit('update:format', 'all');
        }
      }
    },
  },
};
</script>

<style scoped lang="scss">

.programmirovanie__filters {
  padding-block: 10px;
  display: flex;
  gap: 20px;
  transition: 300ms;

  position: sticky;
  z-index: 5;
  background-color: $gray-bg;
  top: calc(var(--scale) * 100);

  @include media-down(tablet) {
    margin-bottom: 20px;
  }

  &:before {
    content: '';
    position: absolute;
    width: 100%;
    top: -10px;
    left: 0;
    height: 10px;
    background-color: $gray-bg;
  }

  ::v-deep .programmirovanie__filters_select {
    width: 295px;
    border: none;
    padding: 13px 20px 16px;

    font-style: normal;
    font-weight: 500;
    font-size: 24px;
    line-height: 130%;
    font-feature-settings: 'pnum' on, 'lnum' on;
    color: $black;

    &:nth-of-type(1) .select_dropdown:before {
      content: 'Предмет';
    }

    &:nth-of-type(2) .select_dropdown:before {
      content: 'Формат';
    }

    &:nth-of-type(3) .select_dropdown {
      @include media-down(desktop) {
        left: auto;
        right: 0;
      }

      &:before {
        content: 'Цель занятия';
      }
    }

    .select_dropdown {
      top: calc(100% + 10px);
      width: 630px;
      display: flex;
      flex-wrap: wrap;
      gap: 4px;
      padding: 32px 30px 50px;
      border-radius: 20px;
      border: none;
      filter: drop-shadow(10px 10px 50px rgba(7, 21, 57, 0.1)) drop-shadow(4px 4px 20px rgba(7, 21, 57, 0.05));

      @include media-down(laptop) {
        width: calc(200% + 20px);
      }

      &:before {
        width: 100%;
        margin-bottom: 12px;

        font-weight: 600;
        font-size: 18px;
        line-height: 100%;
        color: $grey2;
      }
    }

    .programmirovanie__filters_select_close {
      position: absolute;
      z-index: 2;
      top: 10px;
      right: 10px;
      width: 44px;
      height: 44px;
      opacity: 0.5;
      cursor: pointer;

      &:hover {
        opacity: 1;
      }
    }

    &.open {
      border-radius: 16px;
    }

    .select_result,
    .select_inner {
      font-size: inherit;
    }

    .select_item {
      padding: 10px 16px 12px;
      background-color: $ege-card-bg;
      border-radius: 50px;

      font-style: normal;
      font-weight: 600;
      font-size: 16px;
      line-height: 100%;

      &:hover {
        background-color: $gray-bg;
      }

      &.select_item--selected {
        background-color: $black;
        color: $white-color;
      }
    }
  }
}

.programmirovanie__filters-mob {
  padding-inline: 8px;

  &_header {
    margin-bottom: 8px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 44px;

    p {
      font-weight: 600;
      font-size: 18px;
      line-height: 100%;
      color: $grey2;
    }
  }

  &_items {
    display: flex;
    overflow-x: auto;
    gap: 2px;

    width: calc(100% + 32px);
    padding-left: 16px;
    margin-left: -16px;

    &::-webkit-scrollbar {
      display: none;
    }

    button {
      display: flex;
      align-items: center;
      gap: 4px;
      padding: 10px 16px 12px;
      background-color: $white-color;
      border-radius: 50px;

      font-weight: 700;
      font-size: 14px;
      line-height: 100%;
      font-feature-settings: 'pnum' on, 'lnum' on;
      color: $black;
      white-space: nowrap;

      &.active {
        background-color: $black;
        color: $white-color;
      }
    }
  }
}

.programmirovanie__filters-shutter {
  display: grid;
  position: fixed;
  z-index: 51;
  inset: 0;

  &_body {
    position: relative;
    margin-top: auto;
    padding: 32px 16px 16px;
    background-color: $header-card-bg;
    box-shadow: 10px 10px 22px rgba(7, 21, 57, 0.1), 4px 4px 14px rgba(7, 21, 57, 0.05);
    overflow-y: auto;
    height: min(100%, 100vh);
    display: flex;
    flex-direction: column;
  }

  &_close {
    position: fixed;
    z-index: 2;
    right: 0;
    top: 0;
  }

  &_block {
    margin-bottom: 20px;

    &:first-of-type {
      margin-top: auto;
    }

    p {
      margin-bottom: 16px;
      font-weight: 600;
      font-size: 18px;
      line-height: 100%;
      color: $grey2;
    }

    &_items {
      display: flex;
      flex-wrap: wrap;
      gap: 4px;

      button {
        display: flex;
        align-items: center;
        gap: 4px;
        padding: 5px 16px 7px;
        background-color: $white-color;
        border-radius: 50px;

        font-weight: 700;
        font-size: 14px;
        line-height: 100%;
        color: $black;

        &.active {
          background-color: $black;
          color: $white-color;
        }
      }
    }
  }

  &_found {
    margin-top: 8px;

    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 100%;
    text-align: center;
    color: $grey2;
  }

  &_apply {
    width: 100%;
    margin-top: 8px;
    padding: 13px;

    background-color: #FA5019;
    border: 2px solid #892808;
    border-radius: 500px;

    font-weight: 600;
    font-size: 18px;
    line-height: 100%;

    color: $white-color;
  }

  &_bottom {
    //margin-top: auto;
    background-color: $header-card-bg;
    position: sticky;
    bottom: 0;
  }
}

</style>
